module.exports = __webpack_public_path__ + "static/media/DSC_0048.fc9a0405.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0048.jpg
// module id = 549
// module chunks = 0